/**
 * 消息中心 Vuex 模块
 */
import {
  getMessageList,
  getUnreadCount,
  markAsRead,
  markAllAsRead,
  markBatchRead,
  deleteMessage,
  deleteBatch,
  getMessageStats,
} from "@/api/message";

export default {
  namespaced: true,
  state: {
    unreadCount: 0,
    messageList: [],
    total: 0,
    currentPage: 1,
    pageSize: 20,
    filters: {
      messageType: undefined,
      isRead: undefined,
      level: undefined,
    },
    stats: {},
  },
  mutations: {
    setUnreadCount(state, count) {
      state.unreadCount = count;
    },
    setMessageList(state, { list, total, page }) {
      state.messageList = list;
      state.total = total;
      state.currentPage = page;
    },
    setFilters(state, filters) {
      state.filters = { ...state.filters, ...filters };
    },
    resetFilters(state) {
      state.filters = { messageType: undefined, isRead: undefined, level: undefined };
    },
    setStats(state, stats) {
      state.stats = stats;
    },
    // WS 推送新消息，增加未读数
    incrementUnread(state) {
      state.unreadCount++;
    },
  },
  actions: {
    // 获取未读数量
    async fetchUnreadCount({ commit, rootState }) {
      try {
        const userInfo = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_INFO) || "{}");
        const projectId = userInfo.project_id;
        const res = await getUnreadCount({ projectId });
        if (res.code === 200) {
          commit("setUnreadCount", res.data.count);
        }
      } catch (e) {
      }
    },

    // 获取消息列表
    async fetchMessages({ commit, state }) {
      try {
        const userInfo = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_INFO) || "{}");
        const projectId = userInfo.project_id;
        const params = {
          page: state.currentPage,
          pageSize: state.pageSize,
          projectId,
          ...state.filters,
        };
        const res = await getMessageList(params);
        if (res.code === 200) {
          commit("setMessageList", {
            list: res.data.list,
            total: res.data.total,
            page: state.currentPage,
          });
        }
      } catch (e) {
      }
    },

    // 标记已读
    async markRead({ commit, dispatch }, id) {
      try {
        const res = await markAsRead({ id });
        if (res.code === 200) {
          dispatch("fetchUnreadCount");
          dispatch("fetchMessages");
        }
      } catch (e) {
      }
    },

    // 全部已读
    async markAllRead({ commit, dispatch, rootState }, messageType) {
      try {
        const res = await markAllAsRead({ messageType });
        if (res.code === 200) {
          dispatch("fetchUnreadCount");
          dispatch("fetchMessages");
        }
      } catch (e) {
      }
    },

    // 批量已读
    async markBatchRead({ commit, dispatch }, ids) {
      try {
        const res = await markBatchRead({ ids });
        if (res.code === 200) {
          dispatch("fetchUnreadCount");
          dispatch("fetchMessages");
        }
      } catch (e) {
      }
    },

    // 删除消息
    async deleteMessage({ commit, dispatch }, id) {
      try {
        const res = await deleteMessage({ id });
        if (res.code === 200) {
          dispatch("fetchUnreadCount");
          dispatch("fetchMessages");
        }
      } catch (e) {
      }
    },

    // 批量删除
    async deleteBatch({ commit, dispatch }, ids) {
      try {
        const res = await deleteBatch({ ids });
        if (res.code === 200) {
          dispatch("fetchUnreadCount");
          dispatch("fetchMessages");
        }
      } catch (e) {
      }
    },

    // 获取统计
    async fetchStats({ commit }) {
      try {
        const userInfo = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_INFO) || "{}");
        const projectId = userInfo.project_id;
        const res = await getMessageStats({ projectId });
        if (res.code === 200) {
          commit("setStats", res.data);
        }
      } catch (e) {
      }
    },

    // 处理 WS 推送 — 从服务端重新拉取未读数，确保准确
    handleWsPush({ dispatch }, data) {
      if (data.type === "new_message") {
        dispatch("fetchUnreadCount");
      }
    },
  },
};
